import { css } from 'linaria';

export const cardImage = css`
  margin-bottom: 16px;
  width: 100%;

  @media (--to-desktop) {
    margin-bottom: 12px;
  }
`;

export const cardInfoContainer = css`
  display: flex;
  gap: 12px;
`;
